import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InputTextComponent} from './input-text.component';
import {InputPrimitiveModule} from '@tisa-group/client-ui/components/inputs/input-primitive';
import {FormsModule} from '@angular/forms';
import {IconModule} from '@tisa-group/client-ui/components/icon';

@NgModule({
  declarations: [InputTextComponent],
  exports: [InputTextComponent],
  imports: [CommonModule, InputPrimitiveModule, FormsModule, IconModule],
})
export class InputTextModule {}
